import { Container, Form, Nav, Navbar } from "react-bootstrap";
import { AuthCubit } from "../blocs/auth/AuthBloc";
import { AuthState } from "../blocs/auth/authStates";
import useCubit from "../blocs/hooks";
import { ProcessingService, ProcessingState } from "../blocs/processing-service/ProcessingService";
import { UserRight, hasRight } from "../core/models/User";
import Loader from "./Loader";
import LoginButton from "./LoginButton";
import SearchButton from "./SearchButton";
import { WLink } from "./WLInk";


export default function WNavBar() {
  const authCubit = AuthCubit.getInstance();
  const processingService = ProcessingService.getInstance();
  const authState = useCubit<AuthState>(authCubit);
  const processingState = useCubit<ProcessingState>(processingService);

  return <>
    <Navbar expand="lg" className="bg-body-tertiary" fixed="top" style={{
      flexDirection: "column",
      paddingBottom: processingState === 'PROCESSING' ? 0 : 8,
    }}>
      <Container fluid>
        <Navbar.Brand href="/">Hello World! I'm Oussama 🙋</Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" />
        <Navbar.Collapse id="navbarScroll">
          <Nav
            className="me-auto my-2 my-lg-0"
            style={{ maxHeight: '100px' }}
            navbarScroll
          >
            <WLink to="/blog" >📰Blog</WLink>
            <WLink to="/portfolio" >💼Portfolio</WLink>
            <WLink to="/resume" >📗Resume</WLink>
            <WLink to="/contact-me" >💬Contact me</WLink>
            {(authState.state === 'LOGGEDIN' && hasRight(UserRight.canSeeAdminPanel, authState.user!)) && (<WLink to="/admin" >😎Admin</WLink>)}
            {(authState.state === 'LOGGEDIN' && hasRight(UserRight.zahra, authState.user!)) && (<WLink to="/zahra" >🌷Zahra</WLink>)}
            {(authState.state === 'LOGGEDIN' && hasRight(UserRight.zahra, authState.user!)) && (<WLink to="/valentines-day" >❤️‍🔥Will you be my valentine?❤️‍🔥</WLink>)}
          </Nav>
          <Form className="d-flex">
            <SearchButton />
            <div style={{ padding: 4 }} />
            <LoginButton />
          </Form>
        </Navbar.Collapse>
      </Container>
      {processingState === 'PROCESSING' && <Loader />}
    </Navbar>
  </>;
}